module.exports = __webpack_public_path__ + "media/images/lb/093-699929617c55dceabc54258d4a906e76.svg";